import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { pluralize } from "@common/helpers/string";

import { useCategoriesById } from "@hooks/useCategoriesById";
import { BreakableText } from "@design-system/BreakableText/BreakableText";

interface CategoryFilterLabelProps {
    filters: Pick<FiltersTypes, "category">;
}

export const CategoryFilterLabel: React.FC<CategoryFilterLabelProps> = ({
    filters: { category },
}) => {
    const categoriesById = useCategoriesById();

    if (category?.length === 1) {
        return <BreakableText text={categoriesById[category[0]]?.label} />;
    }

    return (
        <>
            {category?.length} {pluralize("Category", category?.length ?? 0)}
        </>
    );
};
